var _path, _path2, _rect, _path3, _path4, _circle, _path5, _circle2, _path6, _rect2, _path7, _circle3, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasketballPlayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flat",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m47 62v-14.07591a6 6 0 0 0 -3.59509-5.49694l-12.40491-5.42715h-12l-12.40491 5.42715a6 6 0 0 0 -3.59509 5.49694v14.07591z",
    fill: "#ffd7a8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m31 39v-5h-12v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2z",
    fill: "#f2cca0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffd7a8",
    height: 33,
    rx: 12,
    width: 24,
    x: 13,
    y: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m24 24h2v4h-2z",
    fill: "#bf9f78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m25 32a7.99016 7.99016 0 0 1 -4.12354-1.14355l1.03223-1.7129a6.103 6.103 0 0 0 6.18262 0l1.03223 1.7129a7.99016 7.99016 0 0 1 -4.12354 1.14355z",
    fill: "#bf9f78"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 22,
    fill: "#8c7558",
    r: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m18 17h4v2h-4z",
    fill: "#806b53"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 22,
    fill: "#8c7558",
    r: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m28 17h4v2h-4z",
    fill: "#806b53"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ff916e",
    height: 7,
    rx: 2,
    width: 28,
    x: 11,
    y: 7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m35 38.75v4.25a5 5 0 0 1 -5 5h-10a5 5 0 0 1 -5-5v-4.25l-5 2.1875v21.0625h30v-21.0625z",
    fill: "#ff916e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    fill: "#ffbc67",
    r: 13
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m50.82831 46.58575.70733.70722a7.00809 7.00809 0 0 0 9.89942 0l-1.41406-1.41406a5.00645 5.00645 0 0 1 -7.07129 0l-.70734-.70722 5.657-5.657-1.41406-1.41406-5.65716 5.65716-.7071-.707a5.0069 5.0069 0 0 1 0-7.07129l-1.41405-1.41407a7.00837 7.00837 0 0 0 0 9.89941l.70709.707-1.41409 1.4141-8.48535-8.48535-1.41406 1.41406 8.48535 8.48535-1.41425 1.41425-.70733-.70722a7.00927 7.00927 0 0 0 -9.89942 0l1.41406 1.41406a5.00646 5.00646 0 0 1 7.07129 0l.70734.70722-5.657 5.657 1.41406 1.41406 5.65716-5.65716.7071.707a5.0069 5.0069 0 0 1 0 7.07129l1.41405 1.41407a7.00837 7.00837 0 0 0 0-9.89941l-.70709-.707 1.41409-1.4141 8.48535 8.48535 1.41406-1.41406-8.48535-8.48535z",
    fill: "#e6a95d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketballPlayer);
export default __webpack_public_path__ + "static/media/basketball-player.5288e11afb1af61adad6834a0b8fcd0b.svg";
export { ForwardRef as ReactComponent };